// Schreiben-Assistent Etappe 2: Briefköpfe und Absender einmal je Seitenaufruf laden (alle Schritte teilen sie).
import { useEffect, useState } from 'react';
import { ladeAbsender, ladeBriefkoepfe, type Absender, type Briefkopf } from '../../../lib/schreiben/gestaltung';

let geladen: Promise<{ koepfe: Briefkopf[]; absender: Absender[] }> | null = null;

export function neuLadenGestaltung() { geladen = null; }

type Gestaltung = { koepfe: Briefkopf[]; absender: Absender[]; bereit: boolean; fehler: string | null };

/** bereit=false + fehler: Laden fehlgeschlagen – Vorschau und Senden bleiben gesperrt (kein stiller Rückfall). */
export function useGestaltung(): Gestaltung {
  const [d, setD] = useState<Gestaltung>({ koepfe: [], absender: [], bereit: false, fehler: null });
  useEffect(() => {
    let aktiv = true;
    geladen ??= Promise.all([ladeBriefkoepfe(), ladeAbsender()]).then(([koepfe, absender]) => ({ koepfe, absender }));
    geladen.then(
      (x) => { if (aktiv) setD({ ...x, bereit: true, fehler: null }); },
      (e: Error) => { geladen = null; if (aktiv) setD((alt) => ({ ...alt, fehler: `${e.message} – Seite neu laden.` })); },
    );
    return () => { aktiv = false; };
  }, []);
  return d;
}
